export default "__VITE_ASSET__ChK1M76i__"